var _defs, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 166 155.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 27.5,
    y1: 3,
    x2: 152,
    y2: 63.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#76b3e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#dcf2fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76b3e1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 95.8,
    y1: 32.6,
    x2: 74,
    y2: 105.2
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#76b3e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4377bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f3b77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 18.4,
    y1: 64.2,
    x2: 144.3,
    y2: 149.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#315aa9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#518ac8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#315aa9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 75.2,
    y1: 74.5,
    x2: 24.4,
    y2: 260.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4377bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1a336b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a336b"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163 35S110-4 69 5l-3 1c-6 2-11 5-14 9l-2 3-15 26 26 5c11 7 25 10 38 7l46 9 18-30z",
    fill: "#76b3e1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M163 35S110-4 69 5l-3 1c-6 2-11 5-14 9l-2 3-15 26 26 5c11 7 25 10 38 7l46 9 18-30z",
    opacity: 0.3,
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52 35l-4 1c-17 5-22 21-13 35 10 13 31 20 48 15l62-21S92 26 52 35z",
    fill: "#518ac8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52 35l-4 1c-17 5-22 21-13 35 10 13 31 20 48 15l62-21S92 26 52 35z",
    opacity: 0.3,
    fill: "url(#b)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M134 80a45 45 0 00-48-15L24 85 4 120l112 19 20-36c4-7 3-15-2-23z",
    fill: "url(#c)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114 115a45 45 0 00-48-15L4 120s53 40 94 30l3-1c17-5 23-21 13-34z",
    fill: "url(#d)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolid);
export default __webpack_public_path__ + "static/media/solid.0091b31ef15a531c0c1563ec9dbfd2fd.svg";
export { ForwardRef as ReactComponent };